var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.2946 18.8275V11.9504H13.1871V8.48438H6.90766V10.6186H1.80015V18.8275H0.0474854V19.9994H20.0471V18.8275H18.2946ZM6.90766 18.8275H2.972V11.7904H6.90766V18.8275ZM12.0152 18.8275H8.07952V9.65623H12.0152L12.0152 18.8275ZM17.1227 18.8275H13.1871V13.1223H17.1227V18.8275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.74195 7.09525L10.0473 6.34738L12.3527 7.09525L12.3539 4.67159L13.7775 2.71018L11.4729 1.96016L10.0473 0L8.62178 1.96012L6.31714 2.71014L7.74078 4.67155L7.74195 7.09525ZM9.34595 2.95678L10.0473 1.99238L10.7487 2.95678L11.8826 3.32579L11.1821 4.29085L11.1815 5.48333L10.0473 5.11537L8.91299 5.48333L8.91244 4.29085L8.21195 3.32579L9.34595 2.95678Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodium);
export default __webpack_public_path__ + "static/media/podium.4ef852220f99b87305ca605c91aadc0f.svg";
export { ForwardRef as ReactComponent };